<template>
    <div class="album-library overflow-y-auto h-screen-header" ref="albumview">
        <section class="album-hero">
            <div class="album-hero__copy">
                <div class="album-hero__label">{{ $tt('专辑收藏') }}</div>
                <h1>{{ $tt('按唱片的方式浏览音乐') }}</h1>
                <p>{{ $tt('保留熟悉的排序入口，同时把筛选、视图和当前状态集中到一个安静的工作区。') }}</p>
            </div>
            <div class="album-hero__stack" aria-hidden="true">
                <div
                    v-for="(cover, index) in heroCovers"
                    :key="index"
                    class="album-hero__cover"
                    :style="{ '--cover-index': index }"
                >
                    <img :src="cover" alt="">
                </div>
            </div>
        </section>

        <section class="album-toolbar">
            <div class="album-toolbar__tabs scrollbar-hide">
                <button
                    v-for="{ value, text } in options"
                    :key="value"
                    type="button"
                    :class="['album-tab', isTabActive(value) ? 'is-active' : '']"
                    @click="handleTabClick(value)"
                >
                    {{ $tt(text) }}
                </button>
            </div>
            <div class="album-toolbar__actions">
                <button
                    type="button"
                    :class="['album-icon-button', showMode === 'grid' ? 'is-active' : '']"
                    :title="$tt('网格视图')"
                    @click="showMode = 'grid'"
                >
                    <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                        <path d="M170.666667 85.333333a85.333333 85.333333 0 0 0-85.333334 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333333-85.333334H170.666667zM170.666667 554.666667a85.333333 85.333333 0 0 0-85.333334 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333333-85.333333H170.666667zM640 85.333333a85.333333 85.333333 0 0 0-85.333333 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333334-85.333334h-213.333333zM640 554.666667a85.333333 85.333333 0 0 0-85.333333 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333334-85.333333h-213.333333z"></path>
                    </svg>
                </button>
                <button
                    type="button"
                    :class="['album-icon-button', showMode === 'list' ? 'is-active' : '']"
                    :title="$tt('列表视图')"
                    @click="showMode = 'list'"
                >
                    <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                        <path d="M134.976 853.312H89.6c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32 0 27.328-20.288 48.256-46.912 48.256zM134.976 560.32H89.6C63.04 560.32 42.688 539.392 42.688 512s20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32s-20.288 48.32-46.912 48.32zM134.976 267.264H89.6c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h45.376c26.624 0 46.912 20.928 46.912 48.256 0 27.392-20.288 48.32-46.912 48.32zM311.744 853.312c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32 0 27.328-20.288 48.256-46.912 48.256H311.744c1.6 0 1.6 0 0 0zM311.744 560.32c-26.56 0-46.912-20.928-46.912-48.32s20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32s-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0zM311.744 267.264c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h622.72c26.56 0 46.848 20.928 46.848 48.256 0 27.392-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0z"></path>
                    </svg>
                </button>
                <button type="button" class="album-filter-button" @click="toggleCustomSettings">
                    <span>{{ showCustomSettings ? $tt('收起筛选') : $tt('筛选') }}</span>
                    <span v-if="activeFilterCount" class="album-filter-count">{{ activeFilterCount }}</span>
                </button>
            </div>
        </section>

        <section class="album-status-strip">
            <div>
                <span class="album-status-strip__label">{{ $tt('当前规则') }}</span>
                <strong>{{ currentSortLabel }}</strong>
            </div>
            <div>
                <span class="album-status-strip__label">{{ $tt('已载入') }}</span>
                <strong>{{ visibleAlbums.length }}</strong>
            </div>
            <div>
                <span class="album-status-strip__label">{{ $tt('有封面') }}</span>
                <strong>{{ coverCount }}</strong>
            </div>
        </section>

        <section v-if="showCustomSettings" class="album-rule-panel">
            <div class="album-rule-panel__header">
                <div>
                    <h2>{{ $tt('自定义过滤规则') }}</h2>
                    <p>{{ $tt('组合排序、年份、歌手和收藏状态，保存后会出现在上方规则栏。') }}</p>
                </div>
                <button type="button" class="btn btn-ghost btn-sm btn-circle" @click="showCustomSettings = false">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>

            <div class="album-rule-grid">
                <div class="form-control">
                    <label class="label"><span class="label-text">{{ $tt('排序方式') }}</span></label>
                    <select v-model="customRules.sortBy" class="select select-bordered select-sm">
                        <option value="name">{{ $tt('专辑名称') }}</option>
                        <option value="artist__name">{{ $tt('歌手名称') }}</option>
                        <option value="max_year">{{ $tt('发行年份') }}</option>
                        <option value="plays_count">{{ $tt('播放次数') }}</option>
                        <option value="created_at">{{ $tt('添加时间') }}</option>
                    </select>
                </div>

                <div class="form-control">
                    <label class="label"><span class="label-text">{{ $tt('排序方向') }}</span></label>
                    <select v-model="customRules.sortOrder" class="select select-bordered select-sm">
                        <option value="asc">{{ $tt('升序') }}</option>
                        <option value="desc">{{ $tt('降序') }}</option>
                    </select>
                </div>

                <div class="form-control">
                    <label class="label"><span class="label-text">{{ $tt('发行年份') }}</span></label>
                    <div class="grid grid-cols-2 gap-2">
                        <input v-model="customRules.yearFrom" type="number" :placeholder="$tt('从')" class="input input-bordered input-sm" min="1900" max="2030">
                        <input v-model="customRules.yearTo" type="number" :placeholder="$tt('到')" class="input input-bordered input-sm" min="1900" max="2030">
                    </div>
                </div>

                <div class="form-control">
                    <label class="label"><span class="label-text">{{ $tt('歌手名称') }}</span></label>
                    <input v-model="customRules.artist" type="text" :placeholder="$tt('输入歌手名称')" class="input input-bordered input-sm">
                </div>

                <div class="form-control">
                    <label class="label"><span class="label-text">{{ $tt('专辑名称') }}</span></label>
                    <input v-model="customRules.album" type="text" :placeholder="$tt('输入专辑名称')" class="input input-bordered input-sm">
                </div>

                <div class="form-control">
                    <label class="label"><span class="label-text">{{ $tt('音乐流派') }}</span></label>
                    <input v-model="customRules.genre" type="text" :placeholder="$tt('输入流派')" class="input input-bordered input-sm">
                </div>
            </div>

            <div class="album-rule-options">
                <div class="form-control">
                    <label class="label"><span class="label-text">{{ $tt('最小播放次数') }}</span></label>
                    <input v-model="customRules.minPlayCount" type="number" placeholder="0" class="input input-bordered input-sm" min="0">
                </div>
                <div class="form-control">
                    <label class="label"><span class="label-text">{{ $tt('最少歌曲数') }}</span></label>
                    <input v-model="customRules.minSongCount" type="number" placeholder="1" class="input input-bordered input-sm" min="1">
                </div>
                <label class="album-check-row">
                    <span>{{ $tt('只显示有封面的专辑') }}</span>
                    <input v-model="customRules.hasCover" type="checkbox" class="checkbox checkbox-sm checkbox-primary">
                </label>
                <label class="album-check-row">
                    <span>{{ $tt('只显示已收藏') }}</span>
                    <input v-model="customRules.starred" type="checkbox" class="checkbox checkbox-sm checkbox-primary">
                </label>
            </div>

            <div class="album-preset-manager">
                <div class="album-preset-manager__title">
                    <h3>{{ $tt('预设选项管理') }}</h3>
                    <span>{{ $tt('显示 {count} 个预设', { count: visiblePresetCount }) }}</span>
                </div>
                <draggable v-model="remoteOptions" group="presets" handle=".drag-handle" @change="savePresetSettings" class="album-preset-list">
                    <div v-for="(option, index) in remoteOptions" :key="option.value" class="album-preset-row">
                        <div class="drag-handle" :title="$tt('拖拽排序')">
                            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M9 4h2v2H9V4zm0 4h2v2H9V8zm0 4h2v2H9v-2zm0 4h2v2H9v-2zm4-12h2v2h-2V4zm0 4h2v2h-2V8zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z"/>
                            </svg>
                        </div>
                        <label class="album-preset-row__label">
                            <input type="checkbox" v-model="option.visible" @change="savePresetSettings" class="checkbox checkbox-sm checkbox-primary">
                            <span>{{ $tt(option.text) }}</span>
                        </label>
                        <span class="album-preset-row__index">{{ index + 1 }}</span>
                        <button v-if="option.type === 'custom'" type="button" class="btn btn-ghost btn-xs btn-circle" @click="removeCustomPreset(option.value)">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>
                </draggable>
            </div>

            <div class="album-rule-panel__footer">
                <div class="flex flex-wrap gap-2">
                    <button type="button" @click="showAllPresets" class="btn btn-ghost btn-xs">{{ $tt('全部显示') }}</button>
                    <button type="button" @click="hideAllPresets" class="btn btn-ghost btn-xs">{{ $tt('全部隐藏') }}</button>
                </div>
                <div class="flex flex-wrap justify-end gap-2">
                    <button type="button" @click="resetCustomRules" class="btn btn-ghost btn-sm">{{ $tt('重置') }}</button>
                    <button type="button" @click="applyCustomRules()" class="btn btn-outline btn-sm">{{ $tt('应用') }}</button>
                    <button type="button" @click="showSaveRuleModal = true" class="btn btn-primary btn-sm">{{ $tt('保存预设') }}</button>
                </div>
            </div>
        </section>

        <div class="modal" :class="{ 'modal-open': showSaveRuleModal }">
            <div class="modal-box album-save-modal relative">
                <button @click="showSaveRuleModal = false" class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <h3 class="font-bold text-lg mb-4">{{ $tt('保存自定义规则') }}</h3>
                <div class="form-control mb-6">
                    <label class="label"><span class="label-text">{{ $tt('规则名称') }}</span></label>
                    <input v-model="newRuleName" type="text" :placeholder="$tt('请输入规则名称')" class="input input-bordered w-full" @keyup.enter="saveCustomRuleWithName" ref="ruleNameInput">
                </div>
                <div class="modal-action">
                    <button @click="saveCustomRuleWithName" class="btn btn-primary btn-sm">{{ $tt('保存') }}</button>
                    <button @click="showSaveRuleModal = false" class="btn btn-ghost btn-sm">{{ $tt('取消') }}</button>
                </div>
            </div>
            <div class="modal-backdrop bg-black/50" @click="showSaveRuleModal = false"></div>
        </div>

        <section class="album-content">
            <AlbumList :items="visibleAlbums" v-if="showMode === 'grid' && visibleAlbums.length" :small="false" />
            <AlbumItems :items="visibleAlbums" v-if="showMode === 'list' && visibleAlbums.length" />

            <div v-if="loading" class="album-loading">
                <div class="album-loading__grid">
                    <span v-for="index in 6" :key="index"></span>
                </div>
                <p>{{ $tt('正在载入专辑') }}</p>
            </div>

            <div v-if="!loading && visibleAlbums.length === 0" class="album-empty">
                <div class="album-empty__art">
                    <span></span>
                </div>
                <h3>{{ $tt('暂无专辑') }}</h3>
                <p>{{ $tt('还没有找到任何专辑，可以切换排序或放宽筛选条件。') }}</p>
                <button v-if="customRulesActive" type="button" class="btn btn-primary btn-sm" @click="clearCustomRules">
                    {{ $tt('清除筛选') }}
                </button>
            </div>
        </section>

        <button v-if="curScrollTop > 700" @click="scrollToTop" class="album-scroll-top" :title="$tt('返回顶部')">
            <svg class="icon h-5 w-5 fill-current" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3c-3.8 5.3-0.1 12.7 6.5 12.7h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"></path>
            </svg>
        </button>
    </div>
</template>
<script>
import AlbumList from './AlbumList'
import AlbumItems from './AlbumItems'
import { mapGetters } from "vuex";
import draggable from 'vuedraggable'

export default {
    name: 'albums',
    components: {
        AlbumList, AlbumItems, draggable
    },
    props: {},
    data() {
        return {
            albums: [],
            loading: false,
            offset: 0,
            hasMore: true,
            showMode: 'grid',
            curScrollTop: 0,
            watchSearchTerm: null,
            searchTimeout: null,
            // 自定义规则相关
            showCustomSettings: false,
            customRulesActive: false,
            customRules: {
                sortBy: 'name',
                sortOrder: 'asc',
                yearFrom: null,
                yearTo: null,
                artist: '',
                album: '',
                genre: '',
                minPlayCount: null,
                minSongCount: null,
                hasCover: false,
                starred: false
            },
            allAlbums: [], // 存储所有专辑数据用于过滤
            filteredAlbums: [], // 过滤后的专辑
            // 规则管理相关
            showSaveRuleModal: false,
            showLoadRuleModal: false,
            newRuleName: '',
            // 预设选项管理
            presetOptions: [
                { text: '最近添加', value: 'recently-added', visible: true },
                { text: '最近播放', value: 'recently-played', visible: true },
                { text: '最多播放', value: 'most-played', visible: true },
                { text: 'A-Z排序', value: 'a-z', visible: true },
                { text: '歌手排序', value: 'artist-sort', visible: true },
                { text: '缺失封面', value: 'less_cover', visible: true },
            ],
            remoteOptions: [],
            currentCustomRule: null, // 当前选中的自定义规则
        }
    },
    computed: {
        ...mapGetters(['getSearchTerm']),
        options() {
            // 确保 remoteOptions 是数组
            if (!Array.isArray(this.remoteOptions)) {
                return []
            }
            return this.remoteOptions.filter(option => option.visible)
        },
        visibleAlbums() {
            return this.customRulesActive ? this.filteredAlbums : this.albums
        },
        currentSortLabel() {
            if (this.customRulesActive && this.currentCustomRule) {
                const customOption = this.remoteOptions.find(option => option.value === this.currentCustomRule)
                return customOption ? this.$tt(customOption.text) : this.$tt('自定义筛选')
            }
            const option = this.options.find(item => item.value === this.sortValue)
            return option ? this.$tt(option.text) : this.$tt('最近添加')
        },
        coverCount() {
            return this.visibleAlbums.filter(album => album && album.image).length
        },
        visiblePresetCount() {
            return Array.isArray(this.remoteOptions)
                ? this.remoteOptions.filter(option => option.visible).length
                : 0
        },
        activeFilterCount() {
            const rules = this.customRules
            return [
                rules.yearFrom,
                rules.yearTo,
                rules.artist,
                rules.album,
                rules.genre,
                rules.minPlayCount,
                rules.minSongCount,
                rules.hasCover,
                rules.starred
            ].filter(value => value !== null && value !== '' && value !== false).length
        },
        heroCovers() {
            const covers = this.visibleAlbums
                .filter(album => album && album.image)
                .slice(0, 3)
                .map(album => album.image)

            while (covers.length < 3) {
                covers.push('/static/dist/img/album_null.jpg')
            }
            return covers
        },
        sortValue: {
            get() {
                return this.$route.params.sort
            }
        },
    },
    mounted() {
        this.loadSavedRules()
    },
    beforeDestroy() {
        // 清理事件监听器
        document.removeEventListener('keydown', this.handleKeyDown)
        if (window.albumview) {
            window.albumview.removeEventListener('scroll', this.listenBottomOut, false)
        }
    },
    destroyed() {
        // 停止观察器
        this.stopWatching()
    },
    async created() {
        // 加载预设设置
        this.loadMore()
    },

    //当组件第一次被创建时，会先触发created,后触发activated
    //当组件被激活时，只会触发activated，不触发created
    activated() {
        this.$refs.albumview.addEventListener('scroll', this.listenBottomOut)
        window.albumview = this.$refs.albumview
        window.albumview.scrollTop = this.curScrollTop || 0
        this.startWatching()

        // 添加键盘事件监听
        document.addEventListener('keydown', this.handleKeyDown)
    },
    deactivated() {
        // 离开页面取消监听
        window.albumview.removeEventListener('scroll', this.listenBottomOut, false)
        this.stopWatching()

        // 移除键盘事件监听
        document.removeEventListener('keydown', this.handleKeyDown)
    },
    methods: {
        startWatching() {
            if (!this.watchSearchTerm) {
                this.watchSearchTerm = this.$watch('getSearchTerm', this.loadSearchTimeout);
            }
        },
        stopWatching() {
            if (this.watchSearchTerm) {
                this.watchSearchTerm()
                this.watchSearchTerm = null
            }
        },
        isTabActive(value) {
            return this.sortValue === value || (this.customRulesActive && this.currentCustomRule === value)
        },
        loadMore() {
            this.loading = true
            return this.$api.subsonic.getAlbums(this.sortValue, 50, this.offset).then(albums => {
                this.albums.push(...albums)
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch((err) => {
                if (err.message === 'Wrong username or password.') {
                    this.$myMsg.notify({
                        title: this.$tt('查询失败！'),
                        content: this.$tt('请在后台管理创建一个subsonic密码，刷新页面试试吧'),
                        type: 'error',
                        time: 5000,
                        url: '/admin/user/userprofile/'
                    })
                    this.$router.push({ name: 'login' })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: err.messagee ? err.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        resetAlbumFeed() {
            this.offset = 0
            this.albums = []
            this.filteredAlbums = []
            this.hasMore = true
            this.customRulesActive = false
            this.currentCustomRule = null
            return this.loadMore()
        },
        loadSearchTimeout() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            this.searchTimeout = setTimeout(() => {
                this.searchTimeout = null
                this.loadSearch()
            }, 300)
        },
        loadSearch() {
            if (this.getSearchTerm === '') {
                this.resetAlbumFeed()
                return
            }
            this.loading = true
            this.offset = 0
            this.hasMore = true
            this.customRulesActive = false
            this.currentCustomRule = null
            return this.$api.subsonic.searchAlbums('search', this.getSearchTerm, 30, this.offset).then(albums => {
                this.albums = albums
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch((err) => {
                if (err.message === 'Wrong username or password.') {
                    this.$myMsg.notify({
                        title: this.$tt('查询失败！'),
                        content: this.$tt('请在后台管理创建一个subsonic密码，刷新页面试试吧'),
                        type: 'error',
                        time: 5000,
                        url: '/admin/user/userprofile/'
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: err.messagee ? err.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        listenBottomOut() {
            if (this.hasMore && !this.loading) {
                const scrollTop = window.albumview.scrollTop
                const scrollHeight = window.albumview.scrollHeight
                const clientHeight = window.albumview.clientHeight
                this.curScrollTop = scrollTop
                if (scrollTop + clientHeight >= scrollHeight - 50) {
                    if (!this.customRulesActive) {
                        this.loadMore()
                    }
                }
            }
        },
        scrollToTop() {
            window.albumview.scrollTop = 0
        },

        // 自定义规则相关方法
        toggleCustomSettings() {
            this.showCustomSettings = !this.showCustomSettings
        },

        // 加载所有专辑数据用于过滤
        async loadAllAlbums() {
            this.loading = true
            try {
                // 分批加载所有专辑
                let allAlbums = []
                let offset = 0
                const limit = 100
                let hasMore = true

                while (hasMore) {
                    const albums = await this.$api.subsonic.getAlbums('a-z', limit, offset)
                    allAlbums.push(...albums)
                    offset += albums.length
                    hasMore = albums.length === limit
                }

                this.allAlbums = allAlbums
                this.filteredAlbums = [...allAlbums]
            } catch (err) {
                this.$myMsg.notify({
                    title: this.$tt('加载失败！'),
                    content: err.message || this.$tt('加载专辑数据失败'),
                    type: 'error',
                    time: 3000,
                })
            } finally {
                this.loading = false
            }
        },

        // 重置规则
        resetCustomRules() {
            this.customRules = {
                sortBy: 'name',
                sortOrder: 'asc',
                yearFrom: null,
                yearTo: null,
                artist: '',
                album: '',
                genre: '',
                minPlayCount: null,
                minSongCount: null,
                hasCover: false,
                starred: false
            }
        },
        clearCustomRules() {
            this.resetCustomRules()
            this.showCustomSettings = false
            return this.resetAlbumFeed()
        },
        getAlbumField(album, field) {
            const fieldMap = {
                name: album.name,
                artist: album.artist,
                artist__name: album.artist,
                max_year: album.year || album.max_year,
                year: album.year || album.max_year,
                plays_count: album.plays_count || album.playCount || 0,
                created_at: album.created || album.created_at,
                created: album.created || album.created_at,
                songCount: album.songCount
            }
            return fieldMap[field]
        },
        async applyCustomRules(ruleValue = 'custom') {
            if (!this.allAlbums.length) {
                await this.loadAllAlbums()
            }

            const rules = this.customRules
            const yearFrom = rules.yearFrom ? Number(rules.yearFrom) : null
            const yearTo = rules.yearTo ? Number(rules.yearTo) : null
            const minPlayCount = rules.minPlayCount ? Number(rules.minPlayCount) : null
            const minSongCount = rules.minSongCount ? Number(rules.minSongCount) : null
            const normalized = value => String(value || '').toLowerCase()

            const filtered = this.allAlbums.filter(album => {
                const albumYear = Number(album.year || album.max_year || 0)
                const playCount = Number(album.plays_count || album.playCount || 0)
                const songCount = Number(album.songCount || 0)

                if (yearFrom && albumYear < yearFrom) return false
                if (yearTo && albumYear > yearTo) return false
                if (rules.artist && !normalized(album.artist).includes(normalized(rules.artist))) return false
                if (rules.album && !normalized(album.name).includes(normalized(rules.album))) return false
                if (rules.genre && !normalized(album.genreId || album.genre).includes(normalized(rules.genre))) return false
                if (minPlayCount !== null && playCount < minPlayCount) return false
                if (minSongCount !== null && songCount < minSongCount) return false
                if (rules.hasCover && !album.image) return false
                if (rules.starred && !album.favourite && !album.starred) return false
                return true
            })

            const sortBy = rules.sortBy || 'name'
            filtered.sort((a, b) => {
                const aValue = this.getAlbumField(a, sortBy)
                const bValue = this.getAlbumField(b, sortBy)
                if (typeof aValue === 'number' || typeof bValue === 'number') {
                    return (Number(aValue) || 0) - (Number(bValue) || 0)
                }
                return normalized(aValue).localeCompare(normalized(bValue))
            })

            this.filteredAlbums = rules.sortOrder === 'desc' ? filtered.reverse() : filtered
            this.customRulesActive = true
            this.currentCustomRule = ruleValue
            this.hasMore = false
            this.showCustomSettings = false
        },

        // 保存自定义规则到后端
        async saveCustomRuleWithName() {
            if (this.newRuleName.trim() === '') {
                this.$myMsg.notify({
                    title: this.$tt('保存失败！'),
                    content: this.$tt('请输入规则名称'),
                    type: 'error',
                    time: 2000,
                })
                return
            }
            this.remoteOptions.push({
                    text: this.newRuleName,
                    value: this.newRuleName,
                    visible: true,
                    type: 'custom',
                    rule: { ...this.customRules }
            })

            try {
                // 保存到后端
                await this.savePresetSettings()
                this.showSaveRuleModal = false
                this.newRuleName = ''
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('保存失败！'),
                    content: error.message || this.$tt('保存规则时出现错误'),
                    type: 'error',
                    time: 3000,
                })
            }
        },

        // 从localStorage载入规则
        loadCustomRule() {
            this.loadSavedRules()
            this.showLoadRuleModal = true
        },

        // 从后端载入保存的规则列表
        async loadSavedRules() {
            try {
                // 从后端获取系统配置
                const response = await this.$api.Task.getSys({'key': 'album_tabs'})
                if (response && response.data.items.length >0) {
                    this.remoteOptions = JSON.parse(response.data.items[0].value)
                }
                if (this.remoteOptions.length === 0) {
                    this.remoteOptions = this.presetOptions
                }
                
            } catch (error) {
                console.error('加载保存的规则失败:', error)
                this.customPresetOptions = []
            }
        },

        // 获取排序字段的中文名称
        getSortText(sortBy) {
            const sortOptions = {
                'name': '专辑名称',
                'artist': '歌手名称',
                'year': '发行年份',
                'playCount': '播放次数',
                'created': '添加时间',
                'starred': '收藏时间'
            }
            return this.$tt(sortOptions[sortBy] || sortBy)
        },

        // 保存预设选项设置到后端
        async savePresetSettings() {
            try {
                // 调用后端保存接口
                await this.$api.Task.UpdateSys({
                    key: 'album_tabs',
                    value: JSON.stringify(this.remoteOptions)
                })

                this.$myMsg.notify({
                    title: this.$tt('预设选项保存成功！'),
                    content: this.$tt('预设选项已保存到服务器'),
                    type: 'success',
                    time: 2000,
                })
            } catch (error) {
                console.error('保存预设设置失败:', error)
                this.$myMsg.notify({
                    title: this.$tt('保存失败！'),
                    content: error.message || this.$tt('保存预设设置时出现错误'),
                    type: 'error',
                    time: 3000,
                })
                throw error
            }
        },

        // 显示所有预设
        async showAllPresets() {
            this.remoteOptions.forEach(p => p.visible = true)
            await this.savePresetSettings()
        },

        // 隐藏所有预设
        async hideAllPresets() {
            this.remoteOptions.forEach(p => p.visible = false)
            await this.savePresetSettings()
        },

        // 移除自定义规则预设
        async removeCustomPreset(value) {
            try {
                this.remoteOptions = this.remoteOptions.filter(p => p.value !== value)
                
                // 调用后端保存接口
                await this.$api.Task.UpdateSys({
                    key: 'album_tabs',
                    value: JSON.stringify(this.remoteOptions)
                })
                
                this.$myMsg.notify({
                    title: this.$tt('移除成功！'),
                    content: this.$tt('自定义预设 "{name}" 已移除', { name: value }),
                    type: 'success',
                    time: 2000,
                })
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('移除失败！'),
                    content: error.message || this.$tt('移除预设时出现错误'),
                    type: 'error',
                    time: 3000,
                })
            }
        },
        // 处理Tab点击事件
        async handleTabClick(value) {
            const option = this.remoteOptions.find(item => item.value === value)
            if (option && option.type === 'custom' && option.rule) {
                this.customRules = { ...this.customRules, ...option.rule }
                await this.applyCustomRules(value)
                return
            }

            this.customRulesActive = false
            this.currentCustomRule = null
            if (this.sortValue === value) {
                return
            }
            this.$router.push({ path: '/albums/' + value })
        },

        // 键盘事件处理
        handleKeyDown(event) {
            // ESC键关闭模态框
            if (event.key === 'Escape') {
                if (this.showSaveRuleModal) {
                    this.showSaveRuleModal = false
                } else if (this.showLoadRuleModal) {
                    this.showLoadRuleModal = false
                } else if (this.showCustomSettings) {
                    this.showCustomSettings = false
                }
            }
        }
    }
}
</script>

<style scoped>
.album-library {
    --album-radius: 18px;
    --album-border: oklch(var(--bc) / 0.12);
    --album-muted: oklch(var(--bc) / 0.62);
    --album-soft: color-mix(in oklch, oklch(var(--b2)) 72%, transparent);
    min-height: 0;
    overflow-x: hidden;
    border-radius: 1rem;
    color: oklch(var(--bc));
    background:
        radial-gradient(circle at 12% 8%, color-mix(in srgb, oklch(var(--p)) 16%, transparent), transparent 28rem),
        radial-gradient(circle at 88% 4%, color-mix(in srgb, oklch(var(--a)) 12%, transparent), transparent 26rem),
        oklch(var(--b2));
    padding: 18px;
}

.album-hero,
.album-toolbar,
.album-status-strip,
.album-rule-panel,
.album-content {
    max-width: 1480px;
    margin-left: auto;
    margin-right: auto;
}

.album-hero {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1.35fr) minmax(220px, 0.65fr);
    gap: 28px;
    align-items: stretch;
    min-height: 220px;
    margin-bottom: 14px;
    border: 1px solid var(--album-border);
    border-radius: var(--album-radius);
    background:
        radial-gradient(circle at 86% 18%, color-mix(in oklch, oklch(var(--p)) 18%, transparent), transparent 24rem),
        linear-gradient(
            105deg,
            oklch(var(--b1) / 0.98) 0%,
            oklch(var(--b1) / 0.96) 42%,
            color-mix(in oklch, oklch(var(--b2)) 88%, oklch(var(--p)) 6%) 68%,
            color-mix(in oklch, oklch(var(--b3)) 84%, oklch(var(--p)) 10%) 100%
        ),
        oklch(var(--b1));
    box-shadow: 0 20px 60px oklch(var(--bc) / 0.08);
    isolation: isolate;
    overflow: hidden;
}

.album-hero__copy {
    padding: clamp(24px, 4vw, 44px);
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.album-hero__label {
    width: fit-content;
    margin-bottom: 14px;
    padding: 5px 10px;
    border-radius: 999px;
    background: oklch(var(--p) / 0.14);
    color: oklch(var(--p));
    font-size: 12px;
    font-weight: 700;
}

.album-hero h1 {
    max-width: 620px;
    margin: 0;
    font-size: clamp(30px, 4vw, 54px);
    line-height: 1.04;
    font-weight: 800;
    letter-spacing: 0;
}

.album-hero p {
    max-width: 56ch;
    margin-top: 16px;
    color: var(--album-muted);
    font-size: 15px;
    line-height: 1.75;
}

.album-hero__stack {
    position: relative;
    min-height: 220px;
    background: transparent;
    isolation: isolate;
    overflow: hidden;
}

.album-hero__stack::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 0;
    background:
        linear-gradient(
            90deg,
            transparent 0%,
            color-mix(in oklch, oklch(var(--b3)) 42%, transparent) 46%,
            color-mix(in oklch, oklch(var(--b3)) 68%, oklch(var(--p)) 8%) 100%
        );
    pointer-events: none;
}

.album-hero__cover {
    position: absolute;
    z-index: 1;
    width: 42%;
    aspect-ratio: 1;
    left: calc(16% + var(--cover-index) * 17%);
    top: calc(50% - var(--cover-index) * 12px);
    border-radius: 16px;
    border: 1px solid oklch(var(--bc) / 0.16);
    box-shadow: 0 18px 40px oklch(var(--bc) / 0.22);
    transform: translateY(-50%) rotate(calc((var(--cover-index) - 1) * 7deg));
    overflow: hidden;
}

.album-hero__cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.album-toolbar {
    position: sticky;
    top: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    margin-bottom: 12px;
    padding: 10px;
    border: 1px solid var(--album-border);
    border-radius: var(--album-radius);
    background: color-mix(in oklch, oklch(var(--b1)) 92%, transparent);
    backdrop-filter: blur(14px);
    z-index: 3;
}

.album-toolbar__tabs {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 1px;
}

.album-tab,
.album-icon-button,
.album-filter-button {
    min-height: 38px;
    border-radius: 999px;
    border: 1px solid transparent;
    background: transparent;
    color: oklch(var(--bc) / 0.72);
    transition: background-color 180ms ease, color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.album-tab {
    flex: 0 0 auto;
    padding: 0 14px;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
}

.album-tab:hover,
.album-icon-button:hover,
.album-filter-button:hover {
    background: oklch(var(--b2));
    color: oklch(var(--bc));
}

.album-tab:active,
.album-icon-button:active,
.album-filter-button:active,
.album-scroll-top:active {
    transform: translateY(1px);
}

.album-tab.is-active,
.album-icon-button.is-active {
    background: oklch(var(--p));
    color: oklch(var(--pc));
    border-color: oklch(var(--p));
}

.album-toolbar__actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.album-icon-button {
    width: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.album-filter-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 0 14px;
    border-color: var(--album-border);
    font-size: 13px;
    font-weight: 800;
}

.album-filter-count {
    display: inline-flex;
    min-width: 20px;
    height: 20px;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: oklch(var(--p));
    color: oklch(var(--pc));
    font-size: 12px;
}

.album-status-strip {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr;
    gap: 10px;
    margin-bottom: 12px;
}

.album-status-strip > div {
    min-width: 0;
    padding: 14px 16px;
    border: 1px solid var(--album-border);
    border-radius: 16px;
    background: var(--album-soft);
}

.album-status-strip__label {
    display: block;
    margin-bottom: 3px;
    color: var(--album-muted);
    font-size: 12px;
}

.album-status-strip strong {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
}

.album-rule-panel {
    margin-bottom: 16px;
    padding: 18px;
    border: 1px solid var(--album-border);
    border-radius: var(--album-radius);
    background: oklch(var(--b1));
    box-shadow: 0 16px 48px oklch(var(--bc) / 0.08);
}

.album-rule-panel__header,
.album-rule-panel__footer,
.album-preset-manager__title,
.album-preset-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
}

.album-rule-panel__header {
    align-items: flex-start;
    margin-bottom: 14px;
}

.album-rule-panel__header h2,
.album-preset-manager__title h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 800;
}

.album-rule-panel__header p,
.album-preset-manager__title span {
    margin-top: 4px;
    color: var(--album-muted);
    font-size: 13px;
}

.album-rule-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.album-rule-options {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    margin-top: 12px;
}

.album-check-row {
    display: flex;
    min-height: 48px;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 0 12px;
    border: 1px solid var(--album-border);
    border-radius: 14px;
    background: oklch(var(--b2) / 0.58);
    font-size: 13px;
    cursor: pointer;
}

.album-preset-manager {
    margin-top: 14px;
    padding: 14px;
    border-radius: 16px;
    background: oklch(var(--b2) / 0.58);
}

.album-preset-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-top: 12px;
}

.album-preset-row {
    min-width: 0;
    padding: 10px;
    border: 1px solid var(--album-border);
    border-radius: 14px;
    background: oklch(var(--b1));
}

.drag-handle {
    color: oklch(var(--bc) / 0.48);
    cursor: move;
}

.album-preset-row__label {
    display: flex;
    min-width: 0;
    flex: 1;
    align-items: center;
    gap: 9px;
    cursor: pointer;
}

.album-preset-row__label span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 700;
}

.album-preset-row__index {
    min-width: 24px;
    text-align: center;
    color: var(--album-muted);
    font-size: 12px;
}

.album-rule-panel__footer {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid var(--album-border);
}

.album-save-modal {
    border-radius: var(--album-radius);
    background: oklch(var(--b1));
}

.album-content {
    padding: 2px 0 28px;
}

.album-loading,
.album-empty {
    display: flex;
    min-height: 260px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    border: 1px solid var(--album-border);
    border-radius: var(--album-radius);
    background: oklch(var(--b1) / 0.74);
    text-align: center;
}

.album-loading__grid {
    display: grid;
    width: min(360px, 74vw);
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.album-loading__grid span {
    aspect-ratio: 1;
    border-radius: 14px;
    background: linear-gradient(110deg, oklch(var(--b2)), oklch(var(--b3)), oklch(var(--b2)));
    background-size: 200% 100%;
}

.album-loading p,
.album-empty p {
    max-width: 36ch;
    color: var(--album-muted);
    font-size: 14px;
}

.album-empty__art {
    position: relative;
    width: 86px;
    height: 86px;
    border-radius: 50%;
    border: 14px solid oklch(var(--bc) / 0.12);
    background: oklch(var(--b2));
}

.album-empty__art span {
    position: absolute;
    inset: 50%;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: oklch(var(--p));
    transform: translate(-50%, -50%);
}

.album-empty h3 {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
}

.album-scroll-top {
    position: fixed;
    right: 24px;
    bottom: 24px;
    display: inline-flex;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: oklch(var(--p));
    color: oklch(var(--pc));
    box-shadow: 0 12px 30px oklch(var(--bc) / 0.2);
    transition: transform 180ms ease, background-color 180ms ease;
    z-index: 4;
}

.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

@media (prefers-reduced-motion: no-preference) {
    .album-hero,
    .album-toolbar,
    .album-status-strip,
    .album-rule-panel,
    .album-content {
        animation: albumFadeIn 360ms ease both;
    }

    .album-loading__grid span {
        animation: albumSkeleton 1.2s ease-in-out infinite;
    }
}

@keyframes albumFadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes albumSkeleton {
    0% {
        background-position: 100% 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 900px) {
    .album-library {
        padding: 12px;
    }

    .album-hero {
        grid-template-columns: 1fr;
    }

    .album-hero__stack {
        min-height: 160px;
    }

    .album-toolbar {
        grid-template-columns: 1fr;
    }

    .album-toolbar__actions {
        justify-content: flex-end;
    }

    .album-rule-grid,
    .album-rule-options,
    .album-preset-list {
        grid-template-columns: 1fr;
    }
}

@media screen and (max-width: 640px) {
    .album-hero__copy {
        padding: 22px;
    }

    .album-hero h1 {
        font-size: 30px;
    }

    .album-status-strip {
        grid-template-columns: 1fr;
    }

    .album-rule-panel__header,
    .album-rule-panel__footer,
    .album-preset-manager__title {
        align-items: stretch;
        flex-direction: column;
    }

    .album-rule-panel__footer > div:last-child {
        justify-content: stretch;
    }

    .album-rule-panel__footer .btn {
        flex: 1 1 auto;
    }

    .album-scroll-top {
        right: 16px;
        bottom: 16px;
    }
}
</style>
